/**
 * Created by ndzak on 4/23/2016.
 */

// SERVICES
import Http from '../services/Http';

// private sector
let $http;

//public sector
export default class UserRepo {

    static $resource = 'users';

    static $me = '/me';

    constructor($auth){
        $http = new Http($auth);
    }

    me(){
        return $http.get(UserRepo.$resource + UserRepo.$me + "?include=profile,roles").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    show(id){
        return $http.get(UserRepo.$resource + "/" + id + "?include=profile.school,categories,roles").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    store(data){
        return $http.post(UserRepo.$resource, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    export(data){
        return $http.post(UserRepo.$resource + "/export", data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    all(){
        return $http.get(UserRepo.$resource + "?include=profile,roles").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    paginate(page, q, orderBy){
        let query = "page=" + page + "&include=profile,roles";
        if(q != ''){
            query += "&q=" + q;
        }

        if(orderBy != ''){
            query += "&orderBy=" + orderBy;
        }

        return $http.get(UserRepo.$resource + "/paginate?" + query).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    categoriesPaginate(id, page, q, orderBy){
        let query = "page=" + page + "&include=";
        if(q != ''){
            query += "&q=" + q;
        }

        if(orderBy != ''){
            query += "&orderBy=" + orderBy;
        }

        return $http.get(UserRepo.$resource + "/" + id + "/categories/paginate?" + query).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    sentencesPaginate(id, page, q, orderBy){
        let query = "page=" + page + "&include=user.profile,categories";
        if(q != ''){
            query += "&q=" + q;
        }

        if(orderBy != ''){
            query += "&orderBy=" + orderBy;
        }

        return $http.get(UserRepo.$resource + "/" + id + "/sentences/paginate?" + query).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    commentsPaginate(id, page, q, orderBy){
        let query = "page=" + page + "&include=user.profile,sentences";
        if(q != ''){
            query += "&q=" + q;
        }

        if(orderBy != ''){
            query += "&orderBy=" + orderBy;
        }

        return $http.get(UserRepo.$resource + "/" + id + "/comments/paginate?" + query).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    newsPaginate(id, page, q, orderBy){
        let query = "page=" + page + "&include=";
        if(q != ''){
            query += "&q=" + q;
        }

        if(orderBy != ''){
            query += "&orderBy=" + orderBy;
        }

        return $http.get(UserRepo.$resource + "/" + id + "/news/paginate?" + query).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    sessionsPaginate(id, page, q, orderBy){
        let query = "page=" + page + "&include=";
        if(q != ''){
            query += "&q=" + q;
        }

        if(orderBy != ''){
            query += "&orderBy=" + orderBy;
        }

        return $http.get(UserRepo.$resource + "/" + id + "/user-sessions/paginate?" + query).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    affiliatesPaginate(id, page, q, orderBy){
      let query = "page=" + page + "&include=";
      if(q != ''){
        query += "&q=" + q;
      }

      if(orderBy != ''){
        query += "&orderBy=" + orderBy;
      }

      return $http.get(UserRepo.$resource + "/" + id + "/affiliates/paginate?" + query).then((response) => {
        return Promise.resolve(response);
      }).catch((response) =>{
        return Promise.reject(response);
      });
    }

    myAffiliatePaginate(page, q, orderBy){
        let query = "page=" + page + "&include=";
        if(q != ''){
            query += "&q=" + q;
        }

        if(orderBy != ''){
            query += "&orderBy=" + orderBy;
        }

        return $http.get(UserRepo.$resource + "/affiliates/paginate?" + query).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    update(id, data){
        return $http.put(UserRepo.$resource + "/" + id, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    delete(id){
        return $http.delete(UserRepo.$resource + "/" + id).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    commentsHistory(page = 1, pagination = 6){
        return $http.get(UserRepo.$resource + UserRepo.$me + "/comments/history?include=sentences.categories&page=" + page + "&pagination=" + pagination).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    favComments(page = 1, pagination = 6){
        return $http.get(UserRepo.$resource + UserRepo.$me + "/comments/favorite?include=sentences.categories&page=" + page + "&pagination=" + pagination).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }


    attachRole(id, role_id){
        return $http.post(UserRepo.$resource + "/" + id + "/roles/" + role_id).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    detachRole(id, role_id){
        return $http.delete(UserRepo.$resource + "/" + id + "/roles/" + role_id).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

}



// WEBPACK FOOTER //
// ./src/repos/UserRepo.js